import module from 'contabilidad/polizas/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

export class ContabilidadPolizasOperadorasempresasComponent {
  idOperadora
  idsEmpresas
  onChange
  empresas = null
  clientes = null

  constructor (ContabilidadPolizas) {
    this.ContabilidadPolizas = ContabilidadPolizas
  }

  $onInit () {
    this.ContabilidadPolizas.obtenerOperadoras()
      .then((data) => (this.empresas = orderBy(data.map((item) => ({id: item.kardex_id_empleado, descripcion: item.nombre})), ['descripcion'])))
  }

  $onChanges (changes) {
    if (changes.idOperadora) {
      this.getClientes()
    }
  }

  actualizar() {
    const data = {ids_empresas: this.idsEmpresas, idOperadora: this.idOperadora}
    this.onChange({$event: {data}})
  }

  getClientes () {
    if (this.idOperadora) {
      this.clientes = null
      this.ContabilidadPolizas.obtenerEmpresas(this.idOperadora)
        .then((data) => (this.clientes = orderBy(data.map((item) => ({id: item.ID_Empresa, descripcion: item.Nombre})), ['descripcion'])))
    } else {
      this.idsEmpresas = undefined
      this.idOperadora = undefined
      this.clientes = null
      this.actualizar()
    }
  }
}

module.component('contabilidadPolizasOperadorasempresas', {
  controller: ContabilidadPolizasOperadorasempresasComponent,
  template,
  bindings: {
    idOperadora: '<',
    idsEmpresas: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/components/operadorasempresas/component.js